import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onAddAdminRes } from "./helper";

const requestConfig = {
  headers: {
    "content-type": "multipart/form-data",
  },
};
const addAdmin = async (data: AdminReqT) =>
  axios.post(Routes.ADD_ADMIN, data, requestConfig);

export const useAddAdmin = () =>
  useMutation({
    mutationKey: [Keys.ADD_ADMIN_MUT],
    mutationFn: addAdmin,
    onSuccess: onAddAdminRes,
  });
